import { IFrequencyTableData } from '../subscription-management.props.autogenerated';

export function parseFrequency(table?: IFrequencyTableData[], id?: string): string | undefined {
    return table?.find(freq => freq.freqId === id)?.freqLabel;
}